export function convertMinutes(minutes: number) {
  const days = Math.floor(minutes / 60 / 24)
  const hours = Math.floor(minutes / 60) % 24
  const mins = minutes % 60
  let str = ""
  if (days > 0) {
    str += days + 'd '
  }
  if (hours > 0 || days > 0) {
    str += hours + 'h '
  }
  str += mins + 'min'
  return str
}
